import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Header from '../../partials/Header/header';
import OperationAreas from '../../partials/OperationAreaItemList/operationAreas';
import { reportDWH } from '../../OperationsAreasBlockSlice';

const OperationsAreasPage = (props) => {

  useEffect(() => {
    props.reportDWH?.({
      actionType: 'IWantToTakeAnActionProcessLobby',
      status: 'Ongoing',
      messageText: 'I Want To Take An Action Lobby Displayed',
    });
  }, []);

  let currentPageView = (
    <div>
    </div>
  );

  return (
    <div className='operations-areas-page'>
      <Header context={props.context}/>
      <div className='page-content'>
        <h2>{props.blockData?.titleOperationsList}</h2>
        <OperationAreas context={props.context} />
      </div>
    </div>
  );

};

const mapStateToProps = (state) => {
  return {
    blockData: state.operationsAreasBlock?.blockData,
  };
};

const mapDispatchToProps = {
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(OperationsAreasPage);
